module.exports = __webpack_public_path__ + "fonts/Roboto-500-latin14.f25d774.woff2";